import { Box } from '@mui/material';
import { BoxProps } from '@mui/material/Box';
import { PropsWithChildren } from 'react';
import { FileWrapperClassName } from '@/components/Board/BoardDetail/Feedback/BoardDetailComment/styled';

const CommentFiles = ({
  children,
  sx,
  ...boxProps
}: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      className={FileWrapperClassName}
      sx={{
        '@media (max-width: 768px)': {
          gridTemplateColumns: '1fr',
        },

        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px',
        boxSizing: 'border-box',
        margin: '12px 0',

        '& > *': {
          minWidth: '0',
        },
        ...sx,
      }}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export default CommentFiles;
